var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.596069,
    y: 0.59375,
    width: 31.4039,
    height: 31.4039,
    rx: 8.06521,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.596069,
    y: 0.59375,
    width: 31.4039,
    height: 31.4039,
    rx: 8.06521,
    fill: "url(#paint0_linear_8644_10066)",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.298 26.1604C18.9145 26.1604 21.4239 25.1208 23.2737 23.2708C25.1238 21.4207 26.1633 18.9114 26.1633 16.295C26.1633 13.6787 25.1238 11.1691 23.2737 9.31932C21.4236 7.46926 18.9143 6.42969 16.298 6.42969C13.6816 6.42969 11.1721 7.46926 9.32225 9.31932C7.47219 11.1694 6.43262 13.6787 6.43262 16.295C6.43262 18.9114 7.47219 21.4209 9.32225 23.2708C11.1723 25.1208 13.6816 26.1604 16.298 26.1604ZM11.5244 22.6596C12.1426 21.5004 13.1613 20.606 14.3907 20.1427C15.6201 19.6797 16.9759 19.6797 18.2053 20.1427C19.4347 20.606 20.4534 21.5004 21.0716 22.6596C19.6955 23.695 18.0202 24.2548 16.298 24.2548C14.5758 24.2548 12.9005 23.695 11.5244 22.6596ZM14.0703 15.6583C14.0703 15.0674 14.305 14.5009 14.7227 14.0831C15.1405 13.6653 15.707 13.4307 16.298 13.4307C16.8889 13.4307 17.4554 13.6653 17.8732 14.0831C18.291 14.5009 18.5256 15.0674 18.5256 15.6583C18.5256 16.2491 18.291 16.8158 17.8732 17.2336C17.4554 17.6514 16.8889 17.886 16.298 17.886C15.707 17.886 15.1405 17.6513 14.7227 17.2336C14.305 16.8158 14.0703 16.2491 14.0703 15.6583ZM16.298 8.33879C18.3094 8.34079 20.2456 9.10467 21.7165 10.4767C23.1876 11.8489 24.0842 13.7271 24.226 15.7336C24.3681 17.74 23.7445 19.7259 22.4814 21.2913C21.7074 20.073 20.5917 19.1101 19.2735 18.5224C20.0289 17.7388 20.4449 16.689 20.4316 15.6007C20.4183 14.5123 19.9766 13.4731 19.2023 12.7082C18.428 11.9432 17.3833 11.5143 16.2949 11.5143C15.2063 11.5143 14.1618 11.9432 13.3875 12.7082C12.613 13.4732 12.1713 14.5123 12.1579 15.6007C12.1446 16.689 12.5606 17.7388 13.3161 18.5224C11.9977 19.1069 10.8831 20.0708 10.1146 21.2913C8.85142 19.7259 8.22789 17.74 8.36997 15.7336C8.51182 13.7271 9.4084 11.8489 10.8795 10.4767C12.3504 9.10462 14.2865 8.34078 16.298 8.33879Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8644_10066",
    x1: -6.48929,
    y1: 1.60205,
    x2: 34.4896,
    y2: 30.9897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8496A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707494"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlaceholder);
export default __webpack_public_path__ + "static/media/ProfilePlaceholder.c1c5091e6c3024abc65c4196523538eb.svg";
export { ForwardRef as ReactComponent };